// components
import{ByTag}from'components/v2/Filters/MultiSelect';export default[ByTag];